define.alias("shared/utils/formatters/create-formatted-industry-hashtags", "calendar/utils/formatters/create-formatted-industry-hashtags");